import React from 'react'
import * as S from './styles'

const Pagination = ({ totalItems, itemsPerPage = 8, currentPage, setCurrentPage, show }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  let startPage, endPage
  const maxDisplayedPages = 9

  const isFirstPage = () => {
    return currentPage === 1
  }
  const isLastPage = () => {
    return currentPage === totalPages
  }
  const previousPage = () => {
    if (isFirstPage()) { return }
    setCurrentPage(currentPage - 1)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  const nextPage = () => {
    if (isLastPage()) { return }
    setCurrentPage(currentPage + 1)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleFirstAndLastPageToDisplay = () => {
    if (currentPage > totalPages) {
      paginate(1)
    }

    if (totalPages <= maxDisplayedPages) {
      startPage = 1
      endPage = totalPages
    } else {
      if (currentPage <= Math.floor(maxDisplayedPages / 2)) {
        startPage = 1
        endPage = maxDisplayedPages
      } else if (currentPage + Math.floor(maxDisplayedPages / 2) >= totalPages) {
        startPage = totalPages - maxDisplayedPages + 1
        endPage = totalPages
      } else {
        startPage = currentPage - Math.floor(maxDisplayedPages / 2)
        endPage = currentPage + Math.floor(maxDisplayedPages / 2)
      }
    }
  }

  const handleEllipsesToDisplay = () => {
    const sequencePages = []
    let count = 1
    for (let i = startPage; i <= endPage; i++) {
      if (totalPages <= 9) {
        sequencePages.push(i)
        continue
      }

      if (currentPage > 5 && i === startPage) {
        sequencePages.push(1)
        count += 1
        continue
      }

      if (currentPage > 5 && count === 2) {
        sequencePages.push('...')
        count += 1
        continue
      }

      if ((totalPages - 5 >= currentPage) && i === (endPage)) {
        sequencePages.push(totalPages)
        count += 1
        continue
      }

      if ((totalPages - currentPage) >= 5 && i === (endPage - 1)) {
        sequencePages.push('...')
        count += 1
        continue
      }

      sequencePages.push(i)
      count += 1
    }
    return sequencePages
  }

  const handlePageNumbers = () => {
    handleFirstAndLastPageToDisplay()
    return handleEllipsesToDisplay()
  }

  const paginate = (selected) => {
    if (typeof (selected) == 'number') {
      setCurrentPage(selected)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  return show && (
    <S.Container>
      <S.PaginationItem key={'first'} onClick={() => previousPage()}>
        <S.ChevronLeftIcon disabled={isFirstPage()} />
      </S.PaginationItem>
      {handlePageNumbers().map((pageNumber, index) => (
        <React.Fragment key={pageNumber + '-' + index}>
          <S.PaginationItem outline={pageNumber === currentPage}
            onClick={() => paginate(pageNumber)}>{pageNumber}</S.PaginationItem>
        </React.Fragment>
      ))}
      <S.PaginationItem key={'last'} onClick={() => nextPage()}>
        <S.ChevronRightIcon disabled={isLastPage()} />
      </S.PaginationItem>
    </S.Container>
  )
}

export default Pagination
